export default __webpack_public_path__ + "static/sales 2-de595864ca1637124c24c98333d8c116.png";